'use strict';

(function ($) {

    $.widget('ui.agTextArea', {

        _create: function () {

            var maxHeight = 200;

            this.element.each(function () {
                    this.setAttribute('style',
                        'height:' +
                        ((this.scrollHeight > maxHeight ? maxHeight : this.scrollHeight) + 4) + 'px;');
                })
                .on('input',
                    function () {
                        $(this).innerHeight((this.scrollHeight > maxHeight ? maxHeight : this.scrollHeight) + 'px');
                    });


            var base = this;

            // init the agField and change event
            this.element.closest('div.ag-field')
                .agField({
                    getValue: function () {
                        return base.element.val();
                    },
                    setValue: function (value) {
                        base.element.val(value);
                    }
                });

            // trigger the "agField" event
            this._on(this.element, {
                'keydown': function (event) {
                    base.element.closest('div.ag-field').trigger('change.ag.field');
                    base.element.closest('div.ag-field').trigger('change_ag_field');
                }
            });

        }

    });

})($);














